import { render, staticRenderFns } from "./BackupTrustees.vue?vue&type=template&id=6c043b6c"
import script from "./BackupTrustees.vue?vue&type=script&lang=js"
export * from "./BackupTrustees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports